import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Container from '../../../Core/Container';
import Image from '../../../Core/Image';

export const Wrapper = styled.div`
  background-color: ${({ colourOverrideBackground_1 }) =>
    colourOverrideBackground_1 || themeGet('colors.primary')};

  &.with-image {
    background-color: ${({ colourOverrideBackground_1 }) =>
      colourOverrideBackground_1 || themeGet('colors.secondary')};
    padding: 50px 0 30px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    &.with-image {
      padding: 70px 0 0;
    }
  }
`;

export const Header = styled(Container)`
  *:first-child {
    color: ${themeGet('colors.text-primary')};

    margin-bottom: 20px;
    text-align: center;
  }

  *:nth-child(2n) {
    color: ${themeGet('colors.text-primary')};
    font-weight: 500;
    font-size: 18px;
    letter-spacing: -0.41px;
    line-height: 24px;

    margin: 0 auto;
    text-align: center;
    max-width: 850px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    *:nth-child(2n) {
      margin: 0 auto 50px;

      font-size: 22px;
      letter-spacing: -0.5px;
      line-height: 38px;
    }
  }
`;

export const StyledContainer = styled(Container)`
  display: flex;
  flex-direction: column;

  @media only screen and (max-width: calc(${themeGet(
      'breakpoints.lg'
    )} - 1px)) {
    width: 100%;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    justify-content: space-between;
    flex-direction: row;
  }
`;

export const Block = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  padding: 50px calc(${themeGet('media.grid-gutter.2')} / 2) 60px;

  color: ${({ colourOverrideCardText }) =>
    colourOverrideCardText || themeGet('colors.text-primary')};

  & + & {
    padding-top: 25px;
  }

  h1,
  h2,
  h3,
  p {
    color: inherit;
    /* for IE */
    width: 100%;
  }

  h2,
  h3 {
    margin-bottom: 35px;
  }

  p {
    margin-bottom: 30px;
  }

  a,
  button {
    margin-top: auto;
  }

  ${Wrapper}.with-image & {
    padding: 30px calc(${themeGet('media.grid-gutter.2')} / 2);

    h2,
    h3 {
      font-size: 20px;
      letter-spacing: 0;
      line-height: 26px;
      margin-bottom: 20px;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    width: 50%;
    padding: 70px 45px 90px;

    & + & {
      padding-top: 70px;
    }

    h2,
    h3 {
      margin-bottom: 30px;
    }

    p {
      margin-bottom: 30px;
    }

    ${Wrapper}.with-image & {
      padding: 0px 45px 90px;

      h2,
      h3 {
        font-size: 26px;
        letter-spacing: -0.5px;
        line-height: 38px;
        margin-bottom: 25px;
      }
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xl')}) {
    padding: 70px 90px 90px;
  }
`;

export const StyledImage = styled(Image)`
  width: 100%;

  margin-bottom: 40px;

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    max-width: 635px;
  }
`;
